<template>
  <div class="text-center mt-5">
    <span class="spinner-border text-danger" role="status"></span>
    <p class="mt-3">Redirection en cours selon votre rôle...</p>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useToast } from 'vue-toastification'

const router = useRouter()
const toast = useToast()

onMounted(() => {
  const user = JSON.parse(localStorage.getItem('user') || '{}')
  const role = user?.roles?.[0]?.toLowerCase() || user?.role?.toLowerCase()

  if (!role) {
    toast.error('❌ Aucun rôle détecté. Redirection par défaut.')
    localStorage.removeItem('user')
    router.push('/Dashboard')
    return
  }

  switch (role) {
    case 'admin':
    case 'superadmin':
      router.push('/employee/certificate-requests/review')
      break
    case 'employee':
      router.push('/employee/certificate-requests/request')
      break
    default:
      toast.error(`❌ Rôle non reconnu : ${role}`)
      router.push('/Dashboard')
  }
})
</script>

<style scoped>
.spinner-border {
  width: 3rem;
  height: 3rem;
}
</style>
